// モールごとの「データの置き場所と呼び方」の差分を1箇所に集約する定義テーブル。
//
// Amazon / 楽天 / Shopify / Yahoo はコレクション名・属性キー・親子の辿り方がそれぞれ違う。
// これを各画面で三項演算子に散らすとモールを増やすたびに組み合わせが爆発するため、
// ここを引くだけで済むようにする。
//
// 注意: Amazon 商品は mall フィールドを持たない（未設定 = amazon 扱い）。
// 参照時は getMallDefinition(product.mall) を使うこと。

const mallDefinitions = {
  amazon: {
    key: 'amazon',
    label: 'Amazon',
    // 所有者
    ownerCollection: 'sellers',
    ownerIdField: 'sellerId',
    // 売上・広告のコレクション
    productSalesCollection: 'amazonProductSales',
    productsSalesCollection: 'amazonProductsSales',
    dailySalesCollection: 'amazonDailySales',
    productAdKpisCollection: 'amazonProductAdKpis',
    productsAdKpisCollection: 'amazonProductsAdKpis',
    // 広告売上のフィールド名（Amazon は sales1d、他は sales）
    adSalesField: 'sales1d',
    // productsSales.values のキー体系（'sku' or 'productId'）
    salesValuesKey: 'sku',
    // 商品属性
    attributesKey: 'amazonAttributes',
    parentField: 'amazonAttributes.parentSku',
    isChildField: 'amazonAttributes.isParent', // Amazon は isParent === false で子を表す
    isChildValue: false,
    // productAdKpis に date の複合インデックスがあるか
    hasAdKpisDateIndex: true,
  },
  rakuten: {
    key: 'rakuten',
    label: '楽天',
    ownerCollection: 'shops',
    ownerIdField: 'shopId',
    productSalesCollection: 'rakutenProductSales',
    productsSalesCollection: 'rakutenProductsSales',
    dailySalesCollection: 'rakutenDailySales',
    productAdKpisCollection: 'rakutenProductAdKpis',
    productsAdKpisCollection: 'rakutenProductsAdKpis',
    adSalesField: 'sales',
    salesValuesKey: 'productId',
    attributesKey: 'rakutenAttributes',
    parentField: 'rakutenAttributes.parentManageNumber',
    isChildField: 'rakutenAttributes.isChild',
    isChildValue: true,
    hasAdKpisDateIndex: false,
  },
  shopify: {
    key: 'shopify',
    label: 'Shopify',
    ownerCollection: 'shops',
    ownerIdField: 'shopId',
    productSalesCollection: 'shopifyProductSales',
    productsSalesCollection: 'shopifyProductsSales',
    dailySalesCollection: 'shopifyDailySales',
    // Shopify 広告は未対応（Shopify 自体は広告配信を持たないため）
    productAdKpisCollection: null,
    productsAdKpisCollection: null,
    adSalesField: 'sales',
    salesValuesKey: 'productId',
    attributesKey: 'shopifyAttributes',
    parentField: 'shopifyAttributes.parentProductGid',
    isChildField: 'shopifyAttributes.isChild',
    isChildValue: true,
    hasAdKpisDateIndex: false,
  },
  yahoo: {
    key: 'yahoo',
    label: 'Yahoo!ショッピング',
    ownerCollection: 'shops',
    ownerIdField: 'shopId',
    productSalesCollection: 'yahooProductSales',
    productsSalesCollection: 'yahooProductsSales',
    dailySalesCollection: 'yahooDailySales',
    // Yahoo 広告(アイテムマッチ等)は未対応
    productAdKpisCollection: null,
    productsAdKpisCollection: null,
    adSalesField: 'sales',
    salesValuesKey: 'productId',
    attributesKey: 'yahooAttributes',
    parentField: 'yahooAttributes.parentItemCode',
    isChildField: 'yahooAttributes.isChild',
    isChildValue: true,
    hasAdKpisDateIndex: false,
  },
};

// mall 未設定の商品は Amazon（sellers 由来）として扱う
const getMallDefinition = (mall) => mallDefinitions[mall] || mallDefinitions.amazon;

// 親商品から子商品を引くための「親の識別子」を返す。
// Amazon/楽天は sku、Shopify は productGid が親キーになる。
const getParentKey = (product) => {
  const mall = product?.mall;
  if (mall === 'shopify') return product?.shopifyAttributes?.productGid ?? null;
  return product?.sku ?? null;
};

exports.mallDefinitions = mallDefinitions;
exports.getMallDefinition = getMallDefinition;
exports.getParentKey = getParentKey;
